import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RichTextEditorComponent } from './rich-text-editor.component';
import { ToolbarComponent } from './toolbar/toolbar.component';

@NgModule({
  declarations: [
    RichTextEditorComponent,
    ToolbarComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [RichTextEditorComponent]
})
export class RichTextEditorModule { }
